
var Globalize = require('globalize/dist/globalize-runtime');
require('globalize/dist/globalize-runtime/number');
require('globalize/dist/globalize-runtime/plural');
require('globalize/dist/globalize-runtime/message');
require('globalize/dist/globalize-runtime/date');
var validateParameterTypeNumber = Globalize._validateParameterTypeNumber;
var validateParameterPresence = Globalize._validateParameterPresence;
var numberRound = Globalize._numberRound;
var numberFormat = Globalize._numberFormat;
var numberFormatterFn = Globalize._numberFormatterFn;
var validateParameterTypeString = Globalize._validateParameterTypeString;
var numberParse = Globalize._numberParse;
var numberParserFn = Globalize._numberParserFn;
var pluralGeneratorFn = Globalize._pluralGeneratorFn;
var validateParameterTypeMessageVariables = Globalize._validateParameterTypeMessageVariables;
var messageFormat = Globalize._messageFormat;
var messageFormatterFn = Globalize._messageFormatterFn;
var validateParameterTypeDate = Globalize._validateParameterTypeDate;
var dateToPartsFormat = Globalize._dateToPartsFormat;
var dateToPartsFormatterFn = Globalize._dateToPartsFormatterFn;
var dateFormat = Globalize._dateFormat;
var dateFormatterFn = Globalize._dateFormatterFn;
var dateTokenizer = Globalize._dateTokenizer;
var dateParse = Globalize._dateParse;
var dateParserFn = Globalize._dateParserFn;

Globalize.a1457377354 = numberFormatterFn(["",,2,0,0,,,,,,"","00","-00","-","",numberRound(),"∞","NaN",{".":",",",":".","%":"%","+":"+","-":"-","E":"E","‰":"‰"},]);
Globalize.a390881354 = numberFormatterFn(["",,4,0,0,,,,,,"","0000","-0000","-","",numberRound(),"∞","NaN",{".":",",",":".","%":"%","+":"+","-":"-","E":"E","‰":"‰"},]);
Globalize.a1432474826 = numberFormatterFn(["",,1,0,0,,,,,,"","0","-0","-","",numberRound(),"∞","NaN",{".":",",",":".","%":"%","+":"+","-":"-","E":"E","‰":"‰"},]);
Globalize.b1827356079 = numberParserFn([{",":".",".":",","%":"%","+":"+","-":"-","E":"E","‰":"‰"},,{"infinity":/^∞/,"nan":/^NaN/,"negativePrefix":/^-/,"negativeSuffix":/^/,"number":/^\d+/,"prefix":/^/,"suffix":/^/}]);
Globalize.a1486123774 = pluralGeneratorFn(function(n
) {
  var s = String(n).split('.'), v0 = !s[1];
  return (n == 1 && v0) ? 'one' : 'other';
});
Globalize.a454592756 = messageFormatterFn((function(  ) {
  return function(d) { return "Anmelden"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a292967894 = messageFormatterFn((function(  ) {
  return function(d) { return "Anmelden"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b1666477227 = messageFormatterFn((function(  ) {
  return function(d) { return "E-Mail-Adresse"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a1924001252 = messageFormatterFn((function(  ) {
  return function(d) { return "Passwort"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b136379005 = messageFormatterFn((function(  ) {
  return function(d) { return "Dies ist ein öffentliches oder gemeinsam genutztes Gerät."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a63486140 = messageFormatterFn((function(  ) {
  return function(d) { return "Nicht dein Gerät? Wenn du hier ein Häkchen setzt, bleibst du auf diesem Gerät nur für kurze Zeit angemeldet."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a2023054423 = messageFormatterFn((function(  ) {
  return function(d) { return "Angemeldet bleiben"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b822833351 = messageFormatterFn((function(  ) {
  return function(d) { return "Wenn du hier ein Häkchen setzt, bleibst du auf diesem Gerät bei deinem Konto angemeldet, bis du dich abmeldest. Setze kein Häkchen, wenn du ein öffentliches Gerät verwendest."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b520570689 = messageFormatterFn((function(  ) {
  return function(d) { return "Passwort vergessen?"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b570911760 = messageFormatterFn((function(  ) {
  return function(d) { return "Weiter"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a1134257347 = messageFormatterFn((function(  ) {
  return function(d) { return "Abbrechen"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b829572378 = messageFormatterFn((function(  ) {
  return function(d) { return "Zurück"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a330021352 = messageFormatterFn((function(  ) {
  return function(d) { return "Neu laden"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b1056581843 = messageFormatterFn((function(  ) {
  return function(d) { return "Indem ich mich anmelde, stimme ich den <a href=" + d["1"] + " " + d["3"] + ">allgemeinen Geschäftsbedingungen</a> und der <a href=" + d["2"] + " " + d["4"] + ">Datenschutzrichtlinie</a> von " + d["0"] + " zu."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b460010923 = messageFormatterFn((function(  ) {
  return function(d) { return "Indem ich mich anmelde, stimme ich den <a href=" + d["1"] + " " + d["5"] + ">allgemeinen Geschäftsbedingungen</a> und der <a href=" + d["2"] + " " + d["6"] + ">Datenschutzrichtlinie</a> von " + d["0"] + " sowie den <a href=" + d["3"] + " " + d["7"] + ">allgemeinen Geschäftsbedingungen für " + d["4"] + "</a> zu."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b1011737757 = messageFormatterFn((function(  ) {
  return function(d) { return "Indem ich mich anmelde, registriere ich mich auch für " + d["4"] + ". Ich stimme den <a href=" + d["1"] + " " + d["5"] + ">allgemeinen Geschäftsbedingungen</a> und der <a href=" + d["2"] + " " + d["6"] + ">Datenschutzrichtlinie</a> von " + d["0"] + " sowie den <a href=" + d["3"] + " " + d["7"] + ">allgemeinen Geschäftsbedingungen für " + d["4"] + "</a> zu."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b920040008 = messageFormatterFn((function(  ) {
  return function(d) { return "Dein Konto wurde aufgrund einer routinemäßigen Sicherheitsüberprüfung vorübergehend pausiert. Keine Sorge – deine Informationen sind sicher, du musst nur dein Passwort zurücksetzen. Klicke dazu einfach unten auf den Link „Passwort vergessen?“ und melde dich dann an."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a1825365170 = messageFormatterFn((function(  ) {
  return function(d) { return "Das Passwort passt nicht zur eingegebenen E-Mail-Adresse. Bitte versuche es erneut."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b2044176663 = messageFormatterFn((function(  ) {
  return function(d) { return "Leider ist bei uns etwas schiefgegangen."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b1594349905 = messageFormatterFn((function(  ) {
  return function(d) { return "Leider ist bei uns etwas schiefgegangen. Bitte warte einen Moment und versuche es dann erneut."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a735254733 = messageFormatterFn((function(  ) {
  return function(d) { return "Bitte gib deine E-Mail-Adresse ein."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b1422432162 = messageFormatterFn((function(  ) {
  return function(d) { return "Gib eine gültige E-Mail-Adresse ein."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b1055558564 = messageFormatterFn((function(  ) {
  return function(d) { return "Bitte gib dein Passwort ein."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a1598714374 = messageFormatterFn((function(  ) {
  return function(d) { return "Anmeldedaten werden überprüft ..."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b312901505 = messageFormatterFn((function(  ) {
  return function(d) { return "Passwort verbergen"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a1440634 = messageFormatterFn((function(  ) {
  return function(d) { return "Passwort anzeigen"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a1737694340 = messageFormatterFn((function(  ) {
  return function(d) { return "Du hast noch kein Konto? <span><a id=\"createAcctRedirectLink\" href=" + d["0"] + ">Jetzt erstellen</a></span>"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a691014601 = messageFormatterFn((function(  ) {
  return function(d) { return "Anmelden"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a1909354496 = messageFormatterFn((function(  ) {
  return function(d) { return "Die Anmeldung über " + d["0"] + " ist nicht mehr möglich"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b155507996 = messageFormatterFn((function(  ) {
  return function(d) { return "Du kannst aber dieselbe E-Mail-Adresse verwenden und dein Passwort zurücksetzen, um auf dein " + d["0"] + "-Konto zuzugreifen. Dies hat keine Auswirkungen auf dein " + d["1"] + "-Konto."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a211848466 = messageFormatterFn((function(  ) {
  return function(d) { return "Klicke einfach unten auf die Schaltfläche, um dein Passwort zurückzusetzen. Beim nächsten Mal kannst du dich dann direkt mit deiner E-Mail-Adresse und deinem neuen Passwort bei " + d["0"] + " anmelden."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a1814623499 = messageFormatterFn((function(  ) {
  return function(d) { return "SSO-Anmeldung"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b232819949 = messageFormatterFn((function(  ) {
  return function(d) { return "Melde dich mit Single Sign-On an"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a867778369 = messageFormatterFn((function(  ) {
  return function(d) { return "Oder verwende dein " + d["0"] + "-Konto"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b1879080588 = messageFormatterFn((function(  ) {
  return function(d) { return "Sammle Punkte für kostenlose Reisen. Spare dank Preisen für Mitglieder. Greife ganz einfach auf deine Reisepläne zu."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b1021697394 = messageFormatterFn((function(  ) {
  return function(d) { return "Sammle nach dieser Reise " + d["0"] + " Expedia Rewards-Punkte."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b550479083 = messageFormatterFn((function(  ) {
  return function(d) { return "Bei " + d["0"] + " anmelden"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b840138263 = messageFormatterFn((function(  ) {
  return function(d) { return "Passwort vergessen"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b1290603282 = messageFormatterFn((function(  ) {
  return function(d) { return "Passwort zurücksetzen"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a300576248 = messageFormatterFn((function(  ) {
  return function(d) { return "Gib deine E-Mail-Adresse ein, damit wir dir einen Link zum Zurücksetzen deines Passworts senden können."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b476293516 = messageFormatterFn((function(  ) {
  return function(d) { return "Link zum Zurücksetzen zusenden"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b6072337 = messageFormatterFn((function(  ) {
  return function(d) { return "Du hast Post!"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a209532055 = messageFormatterFn((function(  ) {
  return function(d) { return "Wir haben eine E-Mail an " + d["0"] + " mit einem Link zum Zurücksetzen des Passworts gesendet."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a209533016 = messageFormatterFn((function(  ) {
  return function(d) { return "Es kann einige Minuten dauern, bis du sie erhältst. Wenn du nach 10 Minuten noch keine E-Mail im Posteingang findest, sieh in deinem Spam-Ordner nach."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b222927170 = messageFormatterFn((function(  ) {
  return function(d) { return "Link erneut senden"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a1432028218 = messageFormatterFn((function(  ) {
  return function(d) { return "Es wurde ein neuer Link gesendet."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b2034509357 = messageFormatterFn((function(  ) {
  return function(d) { return "Konto wird verifiziert ..."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a2004635155 = messageFormatterFn((function(  ) {
  return function(d) { return "Passwort festlegen"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b940392316 = messageFormatterFn((function(  ) {
  return function(d) { return "Schön, dass du wieder da bist"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a959902370 = messageFormatterFn((function(  ) {
  return function(d) { return "Erstelle ein eindeutiges Passwort, um fortzufahren."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a2004678547 = messageFormatterFn((function(  ) {
  return function(d) { return "Es hat geklappt!"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a2090333450 = messageFormatterFn((function(  ) {
  return function(d) { return "Du kannst dich von nun an mit dem neuen Passwort anmelden."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b1426548997 = messageFormatterFn((function(  ) {
  return function(d) { return "Passwort zurücksetzen"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a1107277474 = messageFormatterFn((function(  ) {
  return function(d) { return "Leider ist diese Anfrage abgelaufen. Wenn du immer noch dein Passwort ändern möchtest, klicke unten, um eine neue E-Mail zur Zurücksetzung zu senden."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a669662258 = messageFormatterFn((function(  ) {
  return function(d) { return "Link erneut senden"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a133896413 = messageFormatterFn((function(  ) {
  return function(d) { return "Passwort wird gespeichert ..."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a1808437967 = messageFormatterFn((function(  ) {
  return function(d) { return "Konto erstellen"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b129033283 = messageFormatterFn((function(  ) {
  return function(d) { return "Konto erstellen"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a675214478 = messageFormatterFn((function(  ) {
  return function(d) { return "E-Mail-Adresse"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b666548986 = messageFormatterFn((function(  ) {
  return function(d) { return "Bitte gib deine E-Mail-Adresse ein."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a1062855639 = messageFormatterFn((function(  ) {
  return function(d) { return "Gib eine gültige E-Mail-Adresse ein."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a697790125 = messageFormatterFn((function(  ) {
  return function(d) { return "Vorname"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b728710363 = messageFormatterFn((function(  ) {
  return function(d) { return "Gib bitte deinen Vornamen ein."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b742586479 = messageFormatterFn((function(  ) {
  return function(d) { return "Nachname"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a42681369 = messageFormatterFn((function(  ) {
  return function(d) { return "Bitte gib deinen Nachnamen ein."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b773293806 = messageFormatterFn((function(  ) {
  return function(d) { return "Gib den Namen nur mit Buchstaben ein"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a107795979 = messageFormatterFn((function(  ) {
  return function(d) { return "Passwort"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a893063827 = messageFormatterFn((function(  ) {
  return function(d) { return "Bitte gib dein Passwort ein."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b841435614 = messageFormatterFn((function(  ) {
  return function(d) { return "Bitte gib ein gültiges Passwort ein."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a1768297054 = messageFormatterFn((function(  ) {
  return function(d) { return "Besteht aus 9–64 Zeichen"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a1768298015 = messageFormatterFn((function(  ) {
  return function(d) { return "Kombiniert sowohl Buchstaben als auch Zahlen"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a1768298976 = messageFormatterFn((function(  ) {
  return function(d) { return "Mindestens ein Sonderzeichen (beispielsweise ~ " + "#" + " @ $ % & ! * _ ? ^ -)"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a1768299937 = messageFormatterFn((function(  ) {
  return function(d) { return "Das Passwort darf keine Leerzeichen enthalten"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a822615640 = messageFormatterFn((function(  ) {
  return function(d) { return "Dein Passwort muss 8 bis 64 Zeichen lang sein."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a1213241477 = messageFormatterFn((function(  ) {
  return function(d) { return "Das Passwort darf nicht deine E-Mail-Adresse sein."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b1862522622 = messageFormatterFn((function(  ) {
  return function(d) { return "Das Passwort darf keine Leerzeichen enthalten."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a729930426 = messageFormatterFn((function(  ) {
  return function(d) { return "Indem ich ein Konto erstelle, stimme ich den <a href=" + d["1"] + " " + d["3"] + ">allgemeinen Geschäftsbedingungen</a> und der <a href=" + d["2"] + " " + d["4"] + ">Datenschutzrichtlinie</a> von " + d["0"] + " zu."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a1679668200 = messageFormatterFn((function(  ) {
  return function(d) { return "Indem ich ein Konto erstelle, stimme ich den <a href=" + d["1"] + " " + d["5"] + ">allgemeinen Geschäftsbedingungen</a> und der <a href=" + d["2"] + " " + d["6"] + ">Datenschutzrichtlinie</a> von " + d["0"] + " sowie den <a href=" + d["3"] + " " + d["7"] + ">allgemeinen Geschäftsbedingungen für " + d["4"] + "</a> zu."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a1156851977 = messageFormatterFn((function(  ) {
  return function(d) { return "Ich möchte von " + d["0"] + " Reiseschnäppchen, Sonderangebote und weitere Infos per E-Mail erhalten."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b1071763450 = messageFormatterFn((function(  ) {
  return function(d) { return "Ich möchte von " + d["0"] + " Reiseschnäppchen, Sonderangebote und weitere Infos per E-Mail erhalten. Du kannst Werbe-E-Mails jederzeit abbestellen."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b1649615092 = messageFormatterFn((function(  ) {
  return function(d) { return "Ich möchte von " + d["0"] + " Urlaubsideen, Sonderangebote und weitere Infos per E-Mail erhalten."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b1521051933 = messageFormatterFn((function(  ) {
  return function(d) { return "Ich möchte von " + d["0"] + " Urlaubsideen, Sonderangebote und weitere Infos per E-Mail erhalten. Du kannst Werbe-E-Mails jederzeit abbestellen."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a1907850263 = messageFormatterFn((function(  ) {
  return function(d) { return "Weiter"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a1867894364 = messageFormatterFn((function(  ) {
  return function(d) { return "Du hast bereits ein Konto? <span><a id=\"signinRedirectLink\" href=" + d["0"] + ">Anmelden</a></span>"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a1753525537 = messageFormatterFn((function(  ) {
  return function(d) { return "Willkommen, " + d["0"]; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a1263985541 = messageFormatterFn((function(  ) {
  return function(d) { return "Mit deinem neuen " + d["0"] + "-Konto rückt die Welt ein Stück näher."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b1042611058 = messageFormatterFn((function(  ) {
  return function(d) { return "Weiter"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b1543681917 = messageFormatterFn((function(  ) {
  return function(d) { return "Bitte wähle ein stärkeres Passwort, um fortzufahren."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b1909899192 = messageFormatterFn((function(  ) {
  return function(d) { return "Muss mindestens 8 Zeichen enthalten."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a1145794412 = messageFormatterFn((function(  ) {
  return function(d) { return "Passwortstärke"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b1861207722 = messageFormatterFn((function(  ) {
  return function(d) { return "Schwach"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a624785397 = messageFormatterFn((function(  ) {
  return function(d) { return "Stark"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a1176988107 = messageFormatterFn((function(  ) {
  return function(d) { return "Sehr stark"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a457486842 = messageFormatterFn((function(  ) {
  return function(d) { return "Vermeide berechenbare Buchstabenersetzungen wie „@“ statt „a“."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b1245298718 = messageFormatterFn((function(  ) {
  return function(d) { return "Vermeide die umgekehrte Schreibung von gebräuchlichen Wörtern."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b373113386 = messageFormatterFn((function(  ) {
  return function(d) { return "Schreibe einige, jedoch nicht alle Buchstaben groß."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b544739337 = messageFormatterFn((function(  ) {
  return function(d) { return "Schreibe mehr als nur den ersten Buchstaben groß."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b1584065531 = messageFormatterFn((function(  ) {
  return function(d) { return "Vermeide Daten und Jahre, die mit dir in Verbindung stehen."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b389186949 = messageFormatterFn((function(  ) {
  return function(d) { return "Vermeide die Verwendung der letzten Jahre."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b29000426 = messageFormatterFn((function(  ) {
  return function(d) { return "Vermeide Jahre, die mit dir in Verbindung stehen."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a668178327 = messageFormatterFn((function(  ) {
  return function(d) { return "Vermeide gebräuchliche Zeichenfolgen."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a203188657 = messageFormatterFn((function(  ) {
  return function(d) { return "Vermeide wiederholte Wörter und Zeichen."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a681105493 = messageFormatterFn((function(  ) {
  return function(d) { return "Verwende längere Tastaturmuster und ändere die Tipprichtung mehrmals."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b2044901062 = messageFormatterFn((function(  ) {
  return function(d) { return "Füge mehr Wörter hinzu, die weniger gebräuchlich sind."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a2097770022 = messageFormatterFn((function(  ) {
  return function(d) { return "Verwende mehrere Wörter, doch vermeide gebräuchliche Ausdrücke."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b1448059127 = messageFormatterFn((function(  ) {
  return function(d) { return "Du kannst starke Passwörter ohne die Verwendung von Symbolen, Zahlen oder Großbuchstaben erstellen."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a749962192 = messageFormatterFn((function(  ) {
  return function(d) { return "Diese E-Mail-Adresse ist bereits mit einem " + d["0"] + "-Konto verknüpft."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b930497154 = messageFormatterFn((function(  ) {
  return function(d) { return "Wir haben dir per E-Mail einen Link geschickt, um deine Kontoerstellung abzuschließen."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b1418006867 = messageFormatterFn((function(  ) {
  return function(d) { return "Kontoerstellung ist in Bearbeitung ..."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b281710183 = messageFormatterFn((function(  ) {
  return function(d) { return "Der Vorname muss aus mindestens zwei Buchstaben bestehen"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a1079517749 = messageFormatterFn((function(  ) {
  return function(d) { return "Der Nachname muss aus mindestens zwei Buchstaben bestehen"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a966339655 = messageFormatterFn((function(  ) {
  return function(d) { return "Der Vorname darf maximal 100 Zeichen lang sein"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b1967399709 = messageFormatterFn((function(  ) {
  return function(d) { return "Der Nachname darf maximal 100 Zeichen lang sein"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a1361182082 = messageFormatterFn((function(  ) {
  return function(d) { return "Der Vorname darf keine Sonderzeichen enthalten"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b463800546 = messageFormatterFn((function(  ) {
  return function(d) { return "Der Nachname darf keine Sonderzeichen enthalten"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b1670135712 = messageFormatterFn((function(  ) {
  return function(d) { return "Ich stimme allen unten aufgeführten Punkten zu"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b1800233108 = messageFormatterFn((function(  ) {
  return function(d) { return "Ich bestätige, dass ich mindestens 18 Jahre alt bin und die <a href=" + d["0"] + " " + d["1"] + ">Nutzungsbedingungen</a> und die <a href=" + d["2"] + " " + d["3"] + ">allgemeinen Geschäftsbedingungen von " + d["4"] + "</a> gelesen habe und sie akzeptiere (erforderlich)."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b749095594 = messageFormatterFn((function(  ) {
  return function(d) { return "Ich stimme der Erhebung und Nutzung meiner personenbezogenen Daten gemäß der <a href=" + d["0"] + " " + d["1"] + ">Datenschutzerklärung</a> zu (erforderlich)."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a443863735 = messageFormatterFn((function(  ) {
  return function(d) { return "Ich stimme der Weitergabe meiner personenbezogenen Daten an Dritte in Korea oder im Ausland gemäß der <a href=" + d["0"] + " " + d["1"] + ">Datenschutzerklärung</a> zu (erforderlich)."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a1209048692 = messageFormatterFn((function(  ) {
  return function(d) { return "Bitte akzeptiere die Geschäftsbedingungen, um fortzufahren."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a1633501168 = messageFormatterFn((function(  ) {
  return function(d) { return "Akzeptiere die Bedingungen, um fortzufahren."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a726095852 = messageFormatterFn((function(  ) {
  return function(d) { return "Aktiviere das Kontrollkästchen, um fortzufahren"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b1603936027 = messageFormatterFn((function(  ) {
  return function(d) { return "Oder erstelle ein Konto mit " + d["0"]; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b647829063 = messageFormatterFn((function(  ) {
  return function(d) { return "Vermeide Leerzeichen, deinen Namen, deine E-Mail-Adresse oder Passwörter, die du schon einmal verwendet hast."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a926769347 = messageFormatterFn((function(  ) {
  return function(d) { return "Leider ist bei uns gerade etwas schiefgegangen. Bitte warte einige Minuten und versuche es dann erneut."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b994753687 = messageFormatterFn((function(  ) {
  return function(d) { return "Verifiziere deine Handynummer"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a1355899930 = messageFormatterFn((function(  ) {
  return function(d) { return "Wir senden dir einen einmaligen Verifizierungscode an deine Handynummer, um sicherzustellen, dass dein Konto sicher bleibt."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b1200978419 = messageFormatterFn((function(  ) {
  return function(d) { return "Senden"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a1966023642 = messageFormatterFn((function(  ) {
  return function(d) { return "© " + d["1"] + " " + d["0"] + " Alle Rechte vorbehalten."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a486641448 = messageFormatterFn((function(  ) {
  return function(d) { return "Allgemeine Geschäftsbedingungen"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a177982313 = messageFormatterFn((function(  ) {
  return function(d) { return "Datenschutzerklärung"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a866415616 = messageFormatterFn((function(  ) {
  return function(d) { return "SMS senden"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b930530283 = messageFormatterFn((function(  ) {
  return function(d) { return "Gib den Verifizierungscode ein"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a1873627591 = messageFormatterFn((function(  ) {
  return function(d) { return "Verifizierungscode"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a2144209850 = messageFormatterFn((function(  ) {
  return function(d) { return "Code erneut senden"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a1998641169 = messageFormatterFn((function(  ) {
  return function(d) { return "Handynummer ändern"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a896292803 = messageFormatterFn((function(  ) {
  return function(d) { return "Der Verifizierungscode wurde erneut gesendet."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a860645220 = messageFormatterFn((function(  ) {
  return function(d) { return "Gib den 6-stelligen Verifizierungscode ein, der soeben an " + d["0"] + " gesendet wurde."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b2106498199 = messageFormatterFn((function(  ) {
  return function(d) { return "Verifizierungscode wird überprüft"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b919374402 = messageFormatterFn((function(  ) {
  return function(d) { return "Dieser Code ist falsch. Sende den Code erneut, um es noch einmal zu versuchen."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a1202395208 = messageFormatterFn((function(  ) {
  return function(d) { return "oder weiter mit"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a446183000 = messageFormatterFn((function(  ) {
  return function(d) { return "Spare als Mitglied durchschnittlich " + d["0"] + "% bei Tausenden Hotels – es ist immer kostenlos."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b1280320026 = messageFormatterFn((function(  ) {
  return function(d) { return "oder"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b1859382940 = messageFormatterFn((function(  ) {
  return function(d) { return "Weitere Anmeldemöglichkeiten"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b1859023526 = messageFormatterFn((function(  ) {
  return function(d) { return "Weitere Möglichkeiten zur Kontoerstellung"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b1693661392 = messageFormatterFn((function(  ) {
  return function(d) { return "Konto über Google erstellen"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a1812403983 = messageFormatterFn((function(  ) {
  return function(d) { return "Bei der Anmeldung ist ein Fehler aufgetreten. Bitte versuche es noch einmal oder erstelle über diese Seite ein Konto, um fortzufahren."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b177373815 = messageFormatterFn((function(  ) {
  return function(d) { return "Die Anmeldung per Telefonnummer ist nicht verfügbar. Stelle sicher, dass dein Social-Media-Konto deine E-Mail-Adresse teilen darf."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a481154177 = messageFormatterFn((function(  ) {
  return function(d) { return "Spare als Mitglied " + d["0"] + "% oder mehr bei Tausenden Hotels – es ist immer kostenlos."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a267559782 = messageFormatterFn((function(  ) {
  return function(d) { return "Über Google anmelden"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a2078999141 = messageFormatterFn((function(  ) {
  return function(d) { return "Über NAVER anmelden"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a977016069 = messageFormatterFn((function(  ) {
  return function(d) { return "Du hast die maximale Anzahl von Anmeldeversuchen überschritten. Bitte versuche es später erneut."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b301547048 = messageFormatterFn((function(  ) {
  return function(d) { return "Melde dich mit deinen biometrischen Daten an"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b594128056 = messageFormatterFn((function(  ) {
  return function(d) { return "Mithilfe der biometrischen Anmeldung kannst du auf dein Konto zugreifen, ohne dein Passwort eingeben zu müssen."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a632004277 = messageFormatterFn((function(  ) {
  return function(d) { return "Los geht’s"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b1184479141 = messageFormatterFn((function(  ) {
  return function(d) { return "Später erinnern"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b1845340081 = messageFormatterFn((function(  ) {
  return function(d) { return "Das hat geklappt!"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a664935243 = messageFormatterFn((function(  ) {
  return function(d) { return "Du hast die Anmeldung mit biometrischen Daten aktiviert."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b468697037 = messageFormatterFn((function(  ) {
  return function(d) { return "Mit biometrischen Daten anmelden"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a460699064 = messageFormatterFn((function(  ) {
  return function(d) { return "Passwort verwenden"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a943443741 = messageFormatterFn((function(  ) {
  return function(d) { return "Biometrie verwenden"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b50030838 = messageFormatterFn((function(  ) {
  return function(d) { return "Aktualisiere zum Fortfahren dein Passwort"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b1744713806 = messageFormatterFn((function(  ) {
  return function(d) { return "Um auf dein Konto zugreifen zu können, ist ein Zurücksetzen des Passworts erforderlich."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a1460002456 = messageFormatterFn((function(  ) {
  return function(d) { return "Passwort zurücksetzen"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b85328024 = messageFormatterFn((function(  ) {
  return function(d) { return "Willkommen bei deinen Vorteilen für Mitglieder"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b1931506034 = messageFormatterFn((function(  ) {
  return function(d) { return "Für dein nächstes Abenteuer schenken wir dir $" + d["0"] + " in Punkten!"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a676088930 = messageFormatterFn((function(  ) {
  return function(d) { return "Sie stehen dir unmittelbar in deinem Konto zur Verfügung und können für deine erste Buchung genutzt werden. Halte bei Buchungsabschluss einfach Ausschau nach der Option zum Einlösen."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b1571253616 = messageFormatterFn((function(  ) {
  return function(d) { return "Du bist jetzt Expedia-Mitglied."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b1040988000 = messageFormatterFn((function(  ) {
  return function(d) { return "Spare sofort mit Preisen für Mitglieder und sammle Punkte, wenn du buchst."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b348972651 = messageFormatterFn((function(  ) {
  return function(d) { return "Anmelden oder Konto erstellen"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a125041957 = messageFormatterFn((function(  ) {
  return function(d) { return "Spare als Mitglied durchschnittlich " + d["0"] + "% bei Tausenden Hotels – es ist immer kostenlos."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b511603075 = messageFormatterFn((function(  ) {
  return function(d) { return "Indem du fortfährst, bestätigst du, dass du unsere <a href=" + d["1"] + " " + d["3"] + ">allgemeinen Geschäftsbedingungen</a> und <a href=" + d["2"] + " " + d["4"] + ">Datenschutzerklärung</a> gelesen hast und diesen zustimmst."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b999721723 = messageFormatterFn((function(  ) {
  return function(d) { return "Indem du fortfährst, bestätigst du, dass du unsere <a href=" + d["1"] + " " + d["5"] + ">allgemeinen Geschäftsbedingungen</a> und <a href=" + d["2"] + " " + d["6"] + ">Datenschutzerklärung</a> sowie die <a href=" + d["3"] + " " + d["7"] + ">allgemeinen Geschäftsbedingungen für " + d["4"] + "</a> gelesen hast und diesen zustimmst."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b375756192 = messageFormatterFn((function(  ) {
  return function(d) { return "Indem du fortfährst, bestätigst du, dass du unsere <a href=" + d["1"] + " " + d["4"] + ">allgemeinen Geschäftsbedingungen</a> und <a href=" + d["2"] + " " + d["5"] + ">Datenschutzerklärung</a> sowie die <a href=" + d["3"] + " " + d["6"] + ">allgemeinen Geschäftsbedingungen des Treueprogramms One Key</a> gelesen hast und diesen zustimmst."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b839344764 = messageFormatterFn((function(  ) {
  return function(d) { return "E-Mail-Adresse"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a1525518014 = messageFormatterFn((function(  ) {
  return function(d) { return "Gib eine gültige E-Mail-Adresse ein"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b1100729919 = messageFormatterFn((function(  ) {
  return function(d) { return "Google"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a1297899470 = messageFormatterFn((function(  ) {
  return function(d) { return "Facebook"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b1312963992 = messageFormatterFn((function(  ) {
  return function(d) { return "Apple"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b1806005697 = messageFormatterFn((function(  ) {
  return function(d) { return "Diese Option wird nur für persönliche Geräte empfohlen. Um dein Konto zu schützen, solltest du auf öffentlichen Geräten kein Häkchen hier setzen."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b1429910450 = messageFormatterFn((function(  ) {
  return function(d) { return "Du hast zu oft versucht, dich anzumelden. Bitte warte " + d["0"] + " Minuten, bevor du es wieder versuchst."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a1606536406 = messageFormatterFn((function(  ) {
  return function(d) { return "Du hast zu oft versucht, dich anzumelden. Bitte warte " + d["0"] + " Minute, bevor du es wieder versuchst."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a1611431740 = messageFormatterFn((function(  ) {
  return function(d) { return "Du hast zu oft versucht, dich anzumelden. Bitte warte " + d["0"] + " Minuten, bevor du es wieder versuchst."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a1597973896 = messageFormatterFn((function(  ) {
  return function(d) { return "Du hast zu oft versucht, dich anzumelden. Bitte warte " + d["0"] + " Minuten, bevor du es wieder versuchst."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b1805893051 = messageFormatterFn((function(  ) {
  return function(d) { return "Du hast zu oft versucht, dich anzumelden. Bitte warte " + d["0"] + " Minuten, bevor du es wieder versuchst."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b2130177600 = messageFormatterFn((function(  ) {
  return function(d) { return "Du hast zu oft versucht, dich anzumelden. Bitte warte " + d["0"] + " Minuten, bevor du es wieder versuchst."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a1456890799 = messageFormatterFn((function(  ) {
  return function(d) { return "Entdecke mit einem einzigen Konto für Expedia, Hotels.com und FeWo-direkt eine Welt an Prämien."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b677885015 = messageFormatterFn((function(  ) {
  return function(d) { return "Entdecke mit einem einzigen Konto für Expedia, Hotels.com und FeWo-direkt eine Welt des Reisens."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b536993232 = messageFormatterFn((function(  ) {
  return function(d) { return "Stöbere in Unterkünften, speichere deine Favoriten, plane mit deiner Gruppe und hab deine Buchungsdetails immer griffbereit."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a1289789999 = messageFormatterFn((function(  ) {
  return function(d) { return "Dein Konto wurde aufgrund einer routinemäßigen Sicherheitsüberprüfung vorübergehend pausiert. Keine Sorge – deine Informationen sind sicher, du musst nur dein Passwort zurücksetzen."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a1749083745 = messageFormatterFn((function(  ) {
  return function(d) { return "Melde dich an, buche deine Unterkunft und verdiene OneKeyCash "; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a1028798995 = messageFormatterFn((function(  ) {
  return function(d) { return "Bitte bestätige deine Identität"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b1682299929 = messageFormatterFn((function(  ) {
  return function(d) { return "Gib den Sicherheitscode ein, den wir dir per E-Mail gesendet haben. Schau im Spam-Ordner nach, wenn du in deinem Posteingang nichts findest."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a1969081381 = messageFormatterFn((function(  ) {
  return function(d) { return "Bestätigung deiner E-Mail-Adresse"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b1506443115 = messageFormatterFn((function(  ) {
  return function(d) { return "Gib den Sicherheitscode ein, den wir an " + d["0"] + " gesendet haben, um fortzufahren. Schau im Spam-Ordner nach, wenn du in deinem Posteingang nichts findest."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a589579857 = messageFormatterFn((function(  ) {
  return function(d) { return "6-stelliger Code"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b1282666159 = messageFormatterFn((function(  ) {
  return function(d) { return "Code erneut senden"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a971895528 = messageFormatterFn((function(  ) {
  return function(d) { return "(0:" + d["0"] + ")"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a1767556592 = messageFormatterFn((function(  ) {
  return function(d) { return "Code erneut in " + d["0"] + " Sek. senden"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a1306596928 = messageFormatterFn((function(  ) {
  return function(d) { return "Keine E-Mail erhalten?"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b960852578 = messageFormatterFn((function(  ) {
  return function(d) { return "Du kannst in " + d["0"] + " Sek. einen neuen Code anfordern."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b1923930037 = messageFormatterFn((function(  ) {
  return function(d) { return "Einen neuen Sicherheitscode anfordern"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b753245419 = messageFormatterFn((function(  ) {
  return function(d) { return "Wir haben dir einen neuen sechsstelligen Code per E-Mail gesendet."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b1965027040 = messageFormatterFn((function(  ) {
  return function(d) { return "Stattdessen Passwort eingeben"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b219625055 = messageFormatterFn((function(  ) {
  return function(d) { return "Der Code ist ungültig. Bitte versuche es erneut."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b1328123697 = messageFormatterFn((function(  ) {
  return function(d) { return "Der Code ist abgelaufen. Fordere einen neuen an und versuche es noch einmal."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b160877500 = messageFormatterFn((function(  ) {
  return function(d) { return "Schau im Spam-Ordner nach, wenn du in deinem Posteingang nichts findest."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b1782211157 = messageFormatterFn((function(  ) {
  return function(d) { return "Wir haben einige Änderungen vorgenommen und müssen deine E-Mail-Adresse bestätigen. Gib den Sicherheitscode ein, den wir dir gesendet haben."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b905441932 = messageFormatterFn((function(  ) {
  return function(d) { return "Bei uns ist leider gerade etwas schiefgegangen. Bitte versuche es noch einmal."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b678113731 = messageFormatterFn((function(  ) {
  return function(d) { return "Um deine Anmeldemethode zu aktualisieren, gib den Sicherheitscode ein, den wir dir per E-Mail gesendet haben."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a1818187049 = messageFormatterFn((function(  ) {
  return function(d) { return "Gib dein Passwort ein"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b1350401438 = messageFormatterFn((function(  ) {
  return function(d) { return "Sicheren Code per E-Mail senden"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b968153154 = messageFormatterFn((function(  ) {
  return function(d) { return "Das Passwort passt nicht zur eingegebenen E-Mail-Adresse."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b1211059577 = messageFormatterFn((function(  ) {
  return function(d) { return "Passwort erstellen"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a2035429041 = messageFormatterFn((function(  ) {
  return function(d) { return "Passwort erstellen"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b628260215 = messageFormatterFn((function(  ) {
  return function(d) { return "Du kannst dieselbe E-Mail-Adresse und dasselbe Passwort verwenden, um dich bei Expedia, Hotels.com und FeWo-direkt anzumelden."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a1150829047 = messageFormatterFn((function(  ) {
  return function(d) { return "Passwort erstellen"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a1563303302 = messageFormatterFn((function(  ) {
  return function(d) { return "Erstelle ein Passwort, das du zusätzlich zu anderen sicheren Anmeldemethoden verwenden kannst."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b757033541 = messageFormatterFn((function(  ) {
  return function(d) { return "Neues Passwort festlegen"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a267785445 = messageFormatterFn((function(  ) {
  return function(d) { return "Neues Passwort festlegen"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a95387605 = messageFormatterFn((function(  ) {
  return function(d) { return "Du kannst dich jetzt mit nur einem einzigen Konto bei Expedia, Hotels.com und FeWo-direkt anmelden. Erstelle für dieses Konto ein neues sicheres Passwort."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b1392791253 = messageFormatterFn((function(  ) {
  return function(d) { return "Passwort erstellen"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b820875811 = messageFormatterFn((function(  ) {
  return function(d) { return "Passwort ändern"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b790008589 = messageFormatterFn((function(  ) {
  return function(d) { return "Verwende ein eindeutiges und sicheres Passwort."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a1458325325 = messageFormatterFn((function(  ) {
  return function(d) { return "Passwort aktualisieren"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a301976378 = messageFormatterFn((function(  ) {
  return function(d) { return "Leider konnten wir dein Passwort nicht ändern. Bitte versuche es noch einmal."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a1199713240 = messageFormatterFn((function(  ) {
  return function(d) { return "Passwort vergessen"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a487727106 = messageFormatterFn((function(  ) {
  return function(d) { return "Gib deine E-Mail-Adresse ein und wir senden dir einen Sicherheitscode, mit dem du dich anmelden kannst."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a187270622 = messageFormatterFn((function(  ) {
  return function(d) { return "E-Mail senden"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a1504515370 = messageFormatterFn((function(  ) {
  return function(d) { return "Kontaktiere uns"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b26661115 = messageFormatterFn((function(  ) {
  return function(d) { return "Konto löschen"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b1791473158 = messageFormatterFn((function(  ) {
  return function(d) { return "Schließen."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b1701815266 = messageFormatterFn((function(  ) {
  return function(d) { return "Einen Moment bitte, wir prüfen dein Konto ..."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b1761583263 = messageFormatterFn((function(  ) {
  return function(d) { return "Konto löschen"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a88020677 = messageFormatterFn((function(  ) {
  return function(d) { return "OK"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a2034341087 = messageFormatterFn((function(  ) {
  return function(d) { return "Du kannst dein Konto erst nach Abschluss deiner Reise löschen."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b1773154368 = messageFormatterFn((function(  ) {
  return function(d) { return "Du benötigst das Konto für einen reibungslosen Ablauf deiner Reise, zum Beispiel, um auf deine Buchung zuzugreifen und im Fall von kurzfristigen Änderungen Hilfe vom Kundenservice zu erhalten."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b1053844013 = messageFormatterFn((function(  ) {
  return function(d) { return "Löschen Sie zuerst Ihr Vermieterkonto bei FeWo-direkt"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b580090236 = messageFormatterFn((function(  ) {
  return function(d) { return "Besuchen Sie unsere Hilfeseiten auf der Website oder in der App, um unseren Kundenservice zu kontaktieren und den Vorgang zu starten."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a412058804 = messageFormatterFn((function(  ) {
  return function(d) { return "Bitte versuche es nach deiner Reise erneut."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a1195769553 = messageFormatterFn((function(  ) {
  return function(d) { return "Warum möchtest du dein Konto löschen?"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b1680000354 = messageFormatterFn((function(  ) {
  return function(d) { return "Ich erhalte zu viele E-Mails oder Benachrichtigungen"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a2047504948 = messageFormatterFn((function(  ) {
  return function(d) { return "Ich habe ein anderes " + d["0"] + "-Konto"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a131176303 = messageFormatterFn((function(  ) {
  return function(d) { return "Meine Reise ist beendet, daher benötige ich dieses Konto nicht mehr"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b1531036427 = messageFormatterFn((function(  ) {
  return function(d) { return "Ich hatte eine negative Erfahrung bei der Buchung mit " + d["0"]; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b747114166 = messageFormatterFn((function(  ) {
  return function(d) { return "Sonstiges"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b739406285 = messageFormatterFn((function(  ) {
  return function(d) { return "Überspringen"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a330829306 = messageFormatterFn((function(  ) {
  return function(d) { return "Absenden"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b1507975926 = messageFormatterFn((function(  ) {
  return function(d) { return "Schade, dass du uns verlässt. Hier noch einige Details, die du wissen solltest:"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a2116182723 = messageFormatterFn((function(  ) {
  return function(d) { return "Deine " + d["0"] + " Expedia Rewards-Punkte im Wert von " + d["1"] + ", Gutschriften im Wert von " + d["2"] + ", deine Kontoeinstellungen sowie eventuelle Gutscheine und gespeicherte Reiseprodukte gehen verloren."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b474059122 = messageFormatterFn((function(  ) {
  return function(d) { return "Deine " + d["0"] + " Expedia Rewards-Punkte im Wert von " + d["1"] + ", deine Kontoeinstellungen sowie eventuelle Gutscheine und gespeicherte Reiseprodukte gehen verloren."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a371535120 = messageFormatterFn((function(  ) {
  return function(d) { return "Deine Reiseplaner, Gutschriften und Einstellungen gehen verloren."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b220770874 = messageFormatterFn((function(  ) {
  return function(d) { return "Hotels.com Rewards: Deine " + d["0"] + " Prämiennacht/Prämiennächte im Wert von " + d["1"] + " und " + d["2"] + " Stempel mit einem durchschnittlichen Wert von " + d["3"] + " gehen verloren."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a936896727 = messageFormatterFn((function(  ) {
  return function(d) { return "Deine Gutschriften, Kontoeinstellungen sowie eventuelle Gutscheine und gespeicherte Reiseprodukte gehen verloren."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b667611009 = messageFormatterFn((function(  ) {
  return function(d) { return "Deine " + d["0"] + " CheapCash im Wert von " + d["1"] + ", Gutschriften im Wert von " + d["2"] + ", deine Kontoeinstellungen sowie eventuelle Gutscheine und gespeicherte Reiseprodukte gehen verloren."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b1650257070 = messageFormatterFn((function(  ) {
  return function(d) { return "Deine " + d["0"] + " CheapCash im Wert von " + d["1"] + ", deine Kontoeinstellungen sowie eventuelle Gutscheine und gespeicherte Reiseprodukte gehen verloren."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a1245125047 = messageFormatterFn((function(  ) {
  return function(d) { return "Deine " + d["0"] + " Orbucks im Wert von " + d["1"] + ", Gutschriften im Wert von " + d["2"] + ", deine Kontoeinstellungen sowie eventuelle Gutscheine und gespeicherte Reiseprodukte gehen verloren."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a604870426 = messageFormatterFn((function(  ) {
  return function(d) { return "Deine " + d["0"] + " Orbucks im Wert von " + d["1"] + ", deine Kontoeinstellungen sowie eventuelle Gutscheine und gespeicherte Reiseprodukte gehen verloren."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b757744381 = messageFormatterFn((function(  ) {
  return function(d) { return "Deine " + d["0"] + " MrJet Rewards im Wert von " + d["1"] + ", Gutschriften im Wert von " + d["2"] + ", deine Kontoeinstellungen sowie eventuelle Gutscheine und gespeicherte Reiseprodukte gehen verloren."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a297282638 = messageFormatterFn((function(  ) {
  return function(d) { return "Deine " + d["0"] + " MrJet Rewards im Wert von " + d["1"] + ", deine Kontoeinstellungen sowie eventuelle Gutscheine und gespeicherte Reiseprodukte gehen verloren."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a1026031903 = messageFormatterFn((function(  ) {
  return function(d) { return "Deine " + d["0"] + " BONUS+ und somit dein verdientes Guthaben im Wert von " + d["1"] + ", deine Gutschriften im Wert von " + d["2"] + ", deine Kontoeinstellungen sowie eventuelle Gutscheine und gespeicherte Reiseprodukte gehen verloren."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a1736539826 = messageFormatterFn((function(  ) {
  return function(d) { return "Deine " + d["0"] + " BONUS+ und somit dein verdientes Guthaben im Wert von " + d["1"] + ", deine Kontoeinstellungen sowie eventuelle Gutscheine und gespeicherte Reiseprodukte gehen verloren."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b1220812887 = messageFormatterFn((function(  ) {
  return function(d) { return "Deine Kontoeinstellungen sowie eventuelle Gutscheine und gespeicherte Reiseprodukte gehen verloren."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a1244047486 = messageFormatterFn((function(  ) {
  return function(d) { return "Deine Gutschriften im Wert von " + d["0"] + ", deine Kontoeinstellungen sowie eventuelle Gutscheine und gespeicherte Reiseprodukte gehen verloren."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a671528696 = messageFormatterFn((function(  ) {
  return function(d) { return "Möglicherweise bewahren wir bestimmte Informationen, wie deinen Transaktionsverlauf, sicher auf, um unseren gesetzlichen Verpflichtungen nachzukommen oder für den Fall, dass wir einen Rechtsanspruch begründen, ausüben oder verteidigen müssen. Diese Informationen werden sicher gespeichert und gelöscht, anonymisiert oder dauerhaft unkenntlich gemacht, sobald sie nicht mehr benötigt werden."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a611001588 = messageFormatterFn((function(  ) {
  return function(d) { return "Konto dauerhaft löschen"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a1258407228 = messageFormatterFn((function(  ) {
  return function(d) { return "Konto nicht löschen"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b675483726 = messageFormatterFn((function(  ) {
  return function(d) { return "Wir hoffen, dich bald wieder begrüßen zu dürfen."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a1130349011 = messageFormatterFn((function(  ) {
  return function(d) { return "Da die Bearbeitung deines Löschantrags einige Wochen dauern kann, erhältst du möglicherweise weiterhin Mitteilungen, während unser System aktualisiert wird."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a871797421 = messageFormatterFn((function(  ) {
  return function(d) { return "Versuche es bitte erneut."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b634340844 = messageFormatterFn((function(  ) {
  return function(d) { return "Leider ist ein Systemfehler aufgetreten. Bestätige das Löschen deines Kontos erneut oder versuche es in einigen Minuten noch einmal."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a1300418140 = messageFormatterFn((function(  ) {
  return function(d) { return "Verwerfen"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a1238319157 = messageFormatterFn((function(  ) {
  return function(d) { return "Wie lautet der Name in deinem Reisedokument?"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a299481723 = messageFormatterFn((function(  ) {
  return function(d) { return "Verwende für dein Konto deinen vollständigen Namen, wie er in deinem Reisepass oder Personalausweis steht. Bei deiner nächsten Buchung halten wir dann schon alles für dich bereit."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b1173855639 = messageFormatterFn((function(  ) {
  return function(d) { return "Ich möchte von " + d["0"] + " Angebote und weitere Infos per E-Mail erhalten."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a1083847334 = messageFormatterFn((function(  ) {
  return function(d) { return "Ich möchte von " + d["0"] + " Angebote und weitere Infos per E-Mail erhalten. Marketing-E-Mails können jederzeit abbestellt werden."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a505163361 = messageFormatterFn((function(  ) {
  return function(d) { return "Kontoinformationen"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b2036362889 = messageFormatterFn((function(  ) {
  return function(d) { return "Erhalte E-Mails mit Aktionen, Angeboten und weiteren Informationen von " + d["0"] + ". Du kannst dich jederzeit abmelden."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b2013204973 = messageFormatterFn((function(  ) {
  return function(d) { return "Bleib auf dem Laufenden"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b1077911565 = messageFormatterFn((function(  ) {
  return function(d) { return "Marketing-Einwilligung"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b730598398 = messageFormatterFn((function(  ) {
  return function(d) { return "Expedia Rewards"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b1497928032 = messageFormatterFn((function(  ) {
  return function(d) { return "CheapCash"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b924916584 = messageFormatterFn((function(  ) {
  return function(d) { return "Orbitz Rewards"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b1324836928 = messageFormatterFn((function(  ) {
  return function(d) { return "BONUS+"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a1250464258 = messageFormatterFn((function(  ) {
  return function(d) { return "MrJet"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a1904154791 = messageFormatterFn((function(  ) {
  return function(d) { return "Hotels.com Rewards"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b319381371 = messageFormatterFn((function(  ) {
  return function(d) { return "One Key"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a1266943922 = messageFormatterFn((function(  ) {
  return function(d) { return "Du musst leider warten, bis deine Reise abgeschlossen ist."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a1800145758 = messageFormatterFn((function(  ) {
  return function(d) { return "Du musst leider warten, bis deine bevorstehenden Reisen abgeschlossen sind."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b257377636 = messageFormatterFn((function(  ) {
  return function(d) { return "Falls nötig, hast du in deinem Konto Zugriff auf Buchungsdetails und Hilfe. Bitte versuche es nach deiner Reise erneut."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a1048478536 = messageFormatterFn((function(  ) {
  return function(d) { return "Falls nötig, hast du in deinem Konto Zugriff auf Buchungsdetails und Hilfe. Bitte versuche es erneut, nachdem deine Reisen abgeschlossen sind."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a1010884289 = messageFormatterFn((function(  ) {
  return function(d) { return "Dein Konto kann derzeit leider nicht gelöscht werden."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a961386667 = messageFormatterFn((function(  ) {
  return function(d) { return "Dieses Konto wird auch für die Vermietung von Unterkünften auf FeWo-direkt verwendet. Bevor du dein Konto löschen kannst, musst du dich mit der Vermieter-App von FeWo-direkt oder über die FeWo-direkt-Website anmelden, um deine aktiven Inserate zu entfernen."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b159796188 = messageFormatterFn((function(  ) {
  return function(d) { return "Bitte teile uns mit, warum du dein Konto löschen möchtest."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b404434617 = messageFormatterFn((function(  ) {
  return function(d) { return "Ich habe ein Konto mit einer anderen E-Mail-Adresse"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b1934899384 = messageFormatterFn((function(  ) {
  return function(d) { return "Ich hatte ein negatives Buchungserlebnis"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b1786346595 = messageFormatterFn((function(  ) {
  return function(d) { return "Schade, dass du dein Konto löschst. Bitte beachte, dass das Löschen deines Kontos endgültig ist und deine Daten bei Expedia, Hotels.com und FeWo-direkt beeinflussen kann. Hier noch einige Details, die du wissen solltest:"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a477661864 = messageFormatterFn((function(  ) {
  return function(d) { return "Schade, dass du dein Konto löschst. Bitte beachte, dass das Löschen deines Kontos endgültig ist und deine Daten bei Expedia, Wotif, Hotels.com und FeWo-direkt beeinflussen kann. Hier noch einige Details, die du wissen solltest:"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a1744885375 = messageFormatterFn((function(  ) {
  return function(d) { return "Du verlierst dauerhaft deinen Kontoverlauf, deine Präferenzen und deine gespeicherten Elemente bei Expedia, Hotels.com und FeWo-direkt."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a497921034 = messageFormatterFn((function(  ) {
  return function(d) { return "Du verlierst dauerhaft deinen Kontoverlauf, deine Präferenzen und deine gespeicherten Elemente bei Expedia, Wotif, Hotels.com und FeWo-direkt."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b2034724493 = messageFormatterFn((function(  ) {
  return function(d) { return "Du verlierst dauerhaft alles OneKeyCash, einschließlich ausstehendes OneKeyCash, und deinen One Key-Status mit all seinen Vorteilen."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b1406658327 = messageFormatterFn((function(  ) {
  return function(d) { return "Du verlierst ausstehendes OneKeyCash und deinen One Key-Status mit allen seinen Vorteilen dauerhaft."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a1970862882 = messageFormatterFn((function(  ) {
  return function(d) { return "Du verlierst dauerhaft " + d["0"] + " in OneKeyCash, ausstehendes OneKeyCash und deinen One Key-Status mit all seinen Vorteilen."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a685585396 = messageFormatterFn((function(  ) {
  return function(d) { return "Besitzer einer Hotels.com Rewards-Kreditkarte erhalten keine Prämien mehr für ihre Kartenaktivität."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a855227601 = messageFormatterFn((function(  ) {
  return function(d) { return "Du verlierst dauerhaft alle Expedia Rewards-Punkte, einschließlich aller bestätigten und ausstehenden Expedia Rewards-Punkte, Hotels.com Rewards-Stempel und Prämiennächte sowie Rewards-Stufen."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a2110560583 = messageFormatterFn((function(  ) {
  return function(d) { return "Du verlierst dauerhaft alle ausstehenden Expedia Rewards-Punkte, Hotels.com Rewards-Stempel und Prämiennächte sowie deinen Rewards-Status."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a1848045389 = messageFormatterFn((function(  ) {
  return function(d) { return "Du verlierst dauerhaft alle Gutscheine und Gutschriften für Expedia, Hotels.com oder FeWo-direkt."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b1775930792 = messageFormatterFn((function(  ) {
  return function(d) { return "Du verlierst dauerhaft alle Gutscheine und Gutschriften für Expedia, Wotif, Hotels.com oder FeWo-direkt."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b2067681882 = messageFormatterFn((function(  ) {
  return function(d) { return "Da die Bearbeitung deines Kontolöschantrags für Expedia, Hotels.com und FeWo-direkt einige Wochen dauern kann, erhältst du möglicherweise weiterhin Mitteilungen, während unser System aktualisiert wird."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a356796913 = messageFormatterFn((function(  ) {
  return function(d) { return "Da die Bearbeitung deines Kontolöschantrags für Expedia, Wotif, Hotels.com und FeWo-direkt einige Wochen dauern kann, erhältst du möglicherweise weiterhin Mitteilungen, während unser System aktualisiert wird."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a147843611 = messageFormatterFn((function(  ) {
  return function(d) { return "Wenn du dein Konto löschst, kannst du deine One Key Card nicht mehr verwenden und du verdienst bei deinen Einkäufen kein OneKeyCash mehr. Wells Fargo wird sich mit dir bezüglich der Deaktivierung deiner Karte in Verbindung setzen."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a1869003503 = messageFormatterFn((function(  ) {
  return function(d) { return "Wenn du dein Konto löschst, kannst du deine One Key+ Card nicht mehr verwenden und du verdienst bei deinen Einkäufen kein OneKeyCash mehr. Wells Fargo wird sich mit dir bezüglich der Deaktivierung deiner Karte in Verbindung setzen."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b1479501924 = messageFormatterFn((function(  ) {
  return function(d) { return "Melde dich an oder erstelle ein Konto, um für deine Reise OneKeyCash zu verdienen"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a1501257662 = messageFormatterFn((function(  ) {
  return function(d) { return "Melde dich an oder erstelle ein Konto, um für diesen Aufenthalt Prämien zu sammeln"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a2054134299 = messageFormatterFn((function(  ) {
  return function(d) { return "Als Gast buchen"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a1223403475 = messageFormatterFn((function(  ) {
  return function(d) { return "Anmeldung " + d["0"] + "-Konto: Handynummer hinzufügen"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b1421133571 = messageFormatterFn((function(  ) {
  return function(d) { return "Leider ist etwas schiefgegangen"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a174357033 = messageFormatterFn((function(  ) {
  return function(d) { return "Versuche dich erneut anzumelden."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b2144146144 = messageFormatterFn((function(  ) {
  return function(d) { return "OK"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a277684268 = messageFormatterFn((function(  ) {
  return function(d) { return "Konto"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b1660126312 = dateToPartsFormatterFn({"2":Globalize("de-DE").numberFormatter({"raw":"00"}),"4":Globalize("de-DE").numberFormatter({"raw":"0000"})}, {"pattern":"yyyy-MM-dd","timeSeparator":":"});
Globalize.a1520294616 = dateToPartsFormatterFn({"2":Globalize("de-DE").numberFormatter({"raw":"00"}),"4":Globalize("de-DE").numberFormatter({"raw":"0000"})}, {"pattern":"dd/MM/yyyy","timeSeparator":":"});
Globalize.b535978709 = dateToPartsFormatterFn({"1":Globalize("de-DE").numberFormatter({"raw":"0"}),"4":Globalize("de-DE").numberFormatter({"raw":"0000"})}, {"pattern":"d/M/yyyy","timeSeparator":":"});
Globalize.b1658432667 = dateToPartsFormatterFn({"1":Globalize("de-DE").numberFormatter({"raw":"0"}),"4":Globalize("de-DE").numberFormatter({"raw":"0000"})}, {"pattern":"yyyy/M/d","timeSeparator":":"});
Globalize.a1574435640 = dateToPartsFormatterFn({"2":Globalize("de-DE").numberFormatter({"raw":"00"}),"4":Globalize("de-DE").numberFormatter({"raw":"0000"})}, {"pattern":"dd.MM.yyyy","timeSeparator":":"});
Globalize.b2082275539 = dateToPartsFormatterFn({"1":Globalize("de-DE").numberFormatter({"raw":"0"}),"4":Globalize("de-DE").numberFormatter({"raw":"0000"})}, {"pattern":"d.M.yyyy","timeSeparator":":"});
Globalize.b922809640 = dateToPartsFormatterFn({"2":Globalize("de-DE").numberFormatter({"raw":"00"}),"4":Globalize("de-DE").numberFormatter({"raw":"0000"})}, {"pattern":"yyyy/MM/dd","timeSeparator":":"});
Globalize.a1628576664 = dateToPartsFormatterFn({"2":Globalize("de-DE").numberFormatter({"raw":"00"}),"4":Globalize("de-DE").numberFormatter({"raw":"0000"})}, {"pattern":"dd-MM-yyyy","timeSeparator":":"});
Globalize.b2136896360 = dateToPartsFormatterFn({"2":Globalize("de-DE").numberFormatter({"raw":"00"}),"4":Globalize("de-DE").numberFormatter({"raw":"0000"})}, {"pattern":"MM/dd/yyyy","timeSeparator":":"});
Globalize.b777550101 = dateToPartsFormatterFn({"1":Globalize("de-DE").numberFormatter({"raw":"0"}),"4":Globalize("de-DE").numberFormatter({"raw":"0000"})}, {"pattern":"M/d/yyyy","timeSeparator":":"});
Globalize.a856015672 = dateToPartsFormatterFn({"2":Globalize("de-DE").numberFormatter({"raw":"00"}),"4":Globalize("de-DE").numberFormatter({"raw":"0000"})}, {"pattern":"yyyy.MM.dd","timeSeparator":":"});
Globalize.b468003385 = dateToPartsFormatterFn({}, {"pattern":"EEEEE","timeSeparator":":","days":{"E":{"5":{"sun":"S","mon":"M","tue":"D","wed":"M","thu":"D","fri":"F","sat":"S"}}}});
Globalize.a400514264 = dateToPartsFormatterFn({}, {"pattern":"EEEE","timeSeparator":":","days":{"E":{"4":{"sun":"Sonntag","mon":"Montag","tue":"Dienstag","wed":"Mittwoch","thu":"Donnerstag","fri":"Freitag","sat":"Samstag"}}}});
Globalize.b852731176 = dateToPartsFormatterFn({}, {"pattern":"MMMM","timeSeparator":":","months":{"M":{"4":{"1":"Januar","2":"Februar","3":"März","4":"April","5":"Mai","6":"Juni","7":"Juli","8":"August","9":"September","10":"Oktober","11":"November","12":"Dezember"}}}});
Globalize.a1445632264 = dateToPartsFormatterFn({"1":Globalize("de-DE").numberFormatter({"raw":"0"})}, {"pattern":"d","timeSeparator":":"});
Globalize.b1721561013 = dateToPartsFormatterFn({"1":Globalize("de-DE").numberFormatter({"raw":"0"}),"2":Globalize("de-DE").numberFormatter({"raw":"00"})}, {"pattern":"M/d/yy","timeSeparator":":"});
Globalize.a491159190 = dateToPartsFormatterFn({"1":Globalize("de-DE").numberFormatter({"raw":"0"})}, {"pattern":"d. MMM","timeSeparator":":","months":{"M":{"3":{"1":"Jan.","2":"Feb.","3":"März","4":"Apr.","5":"Mai","6":"Juni","7":"Juli","8":"Aug.","9":"Sept.","10":"Okt.","11":"Nov.","12":"Dez."}}}});
Globalize.b1973295437 = dateToPartsFormatterFn({"1":Globalize("de-DE").numberFormatter({"raw":"0"})}, {"pattern":"d. MMMM","timeSeparator":":","months":{"M":{"4":{"1":"Januar","2":"Februar","3":"März","4":"April","5":"Mai","6":"Juni","7":"Juli","8":"August","9":"September","10":"Oktober","11":"November","12":"Dezember"}}}});
Globalize.a1014404706 = dateToPartsFormatterFn({"1":Globalize("de-DE").numberFormatter({"raw":"0"})}, {"pattern":"d. MMMM y","timeSeparator":":","months":{"M":{"4":{"1":"Januar","2":"Februar","3":"März","4":"April","5":"Mai","6":"Juni","7":"Juli","8":"August","9":"September","10":"Oktober","11":"November","12":"Dezember"}}}});
Globalize.a1695230078 = dateToPartsFormatterFn({"1":Globalize("de-DE").numberFormatter({"raw":"0"})}, {"pattern":"MMMM y","timeSeparator":":","months":{"M":{"4":{"1":"Januar","2":"Februar","3":"März","4":"April","5":"Mai","6":"Juni","7":"Juli","8":"August","9":"September","10":"Oktober","11":"November","12":"Dezember"}}}});
Globalize.a1695915271 = dateToPartsFormatterFn({"1":Globalize("de-DE").numberFormatter({"raw":"0"})}, {"pattern":"d. MMM y","timeSeparator":":","months":{"M":{"3":{"1":"Jan.","2":"Feb.","3":"März","4":"Apr.","5":"Mai","6":"Juni","7":"Juli","8":"Aug.","9":"Sept.","10":"Okt.","11":"Nov.","12":"Dez."}}}});
Globalize.a1218141142 = dateToPartsFormatterFn({"1":Globalize("de-DE").numberFormatter({"raw":"0"})}, {"pattern":"EEEE, d. MMM","timeSeparator":":","days":{"E":{"4":{"sun":"Sonntag","mon":"Montag","tue":"Dienstag","wed":"Mittwoch","thu":"Donnerstag","fri":"Freitag","sat":"Samstag"}}},"months":{"M":{"3":{"1":"Jan.","2":"Feb.","3":"März","4":"Apr.","5":"Mai","6":"Juni","7":"Juli","8":"Aug.","9":"Sept.","10":"Okt.","11":"Nov.","12":"Dez."}}}});
Globalize.b1980683605 = dateToPartsFormatterFn({"1":Globalize("de-DE").numberFormatter({"raw":"0"})}, {"pattern":"E, d. MMM","timeSeparator":":","days":{"E":{"1":{"sun":"So.","mon":"Mo.","tue":"Di.","wed":"Mi.","thu":"Do.","fri":"Fr.","sat":"Sa."}}},"months":{"M":{"3":{"1":"Jan.","2":"Feb.","3":"März","4":"Apr.","5":"Mai","6":"Juni","7":"Juli","8":"Aug.","9":"Sept.","10":"Okt.","11":"Nov.","12":"Dez."}}}});
Globalize.b1281412561 = dateFormatterFn(Globalize("de-DE").dateToPartsFormatter({"raw":"yyyy-MM-dd"}));
Globalize.a1899008367 = dateFormatterFn(Globalize("de-DE").dateToPartsFormatter({"raw":"dd/MM/yyyy"}));
Globalize.a1278938498 = dateFormatterFn(Globalize("de-DE").dateToPartsFormatter({"raw":"d/M/yyyy"}));
Globalize.a156484540 = dateFormatterFn(Globalize("de-DE").dateToPartsFormatter({"raw":"yyyy/M/d"}));
Globalize.a1953149391 = dateFormatterFn(Globalize("de-DE").dateToPartsFormatter({"raw":"dd.MM.yyyy"}));
Globalize.b267358332 = dateFormatterFn(Globalize("de-DE").dateToPartsFormatter({"raw":"d.M.yyyy"}));
Globalize.b544095889 = dateFormatterFn(Globalize("de-DE").dateToPartsFormatter({"raw":"yyyy/MM/dd"}));
Globalize.a2007290415 = dateFormatterFn(Globalize("de-DE").dateToPartsFormatter({"raw":"dd-MM-yyyy"}));
Globalize.b1758182609 = dateFormatterFn(Globalize("de-DE").dateToPartsFormatter({"raw":"MM/dd/yyyy"}));
Globalize.a1037367106 = dateFormatterFn(Globalize("de-DE").dateToPartsFormatter({"raw":"M/d/yyyy"}));
Globalize.a1234729423 = dateFormatterFn(Globalize("de-DE").dateToPartsFormatter({"raw":"yyyy.MM.dd"}));
Globalize.b619176752 = dateFormatterFn(Globalize("de-DE").dateToPartsFormatter({"raw":"EEEEE"}));
Globalize.b435646289 = dateFormatterFn(Globalize("de-DE").dateToPartsFormatter({"raw":"EEEE"}));
Globalize.b1688891729 = dateFormatterFn(Globalize("de-DE").dateToPartsFormatter({"raw":"MMMM"}));
Globalize.a2028915857 = dateFormatterFn(Globalize("de-DE").dateToPartsFormatter({"raw":"d"}));
Globalize.b2112968094 = dateFormatterFn(Globalize("de-DE").dateToPartsFormatter({"raw":"M/d/yy"}));
Globalize.a919017759 = dateFormatterFn(Globalize("de-DE").dateToPartsFormatter({"skeleton":"MMMd"}));
Globalize.b1594581686 = dateFormatterFn(Globalize("de-DE").dateToPartsFormatter({"skeleton":"MMMMd"}));
Globalize.b130370901 = dateFormatterFn(Globalize("de-DE").dateToPartsFormatter({"skeleton":"yMMMMd"}));
Globalize.a2073943829 = dateFormatterFn(Globalize("de-DE").dateToPartsFormatter({"skeleton":"yMMMM"}));
Globalize.a2074629022 = dateFormatterFn(Globalize("de-DE").dateToPartsFormatter({"skeleton":"yMMMd"}));
Globalize.a600410591 = dateFormatterFn(Globalize("de-DE").dateToPartsFormatter({"skeleton":"MMMEEEEd"}));
Globalize.b1601969854 = dateFormatterFn(Globalize("de-DE").dateToPartsFormatter({"skeleton":"MMMEd"}));
Globalize.a332649182 = dateParserFn(Globalize("de-DE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"yyyy-MM-dd","digitsRe":/\d/});
Globalize.b781897186 = dateParserFn(Globalize("de-DE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"dd/MM/yyyy","digitsRe":/\d/});
Globalize.a489557489 = dateParserFn(Globalize("de-DE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d/M/yyyy","digitsRe":/\d/});
Globalize.b632896469 = dateParserFn(Globalize("de-DE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"yyyy/M/d","digitsRe":/\d/});
Globalize.b727756162 = dateParserFn(Globalize("de-DE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"dd.MM.yyyy","digitsRe":/\d/});
Globalize.b1056739341 = dateParserFn(Globalize("de-DE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d.M.yyyy","digitsRe":/\d/});
Globalize.a1069965854 = dateParserFn(Globalize("de-DE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"yyyy/MM/dd","digitsRe":/\d/});
Globalize.b673615138 = dateParserFn(Globalize("de-DE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"dd-MM-yyyy","digitsRe":/\d/});
Globalize.b144120866 = dateParserFn(Globalize("de-DE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"MM/dd/yyyy","digitsRe":/\d/});
Globalize.a247986097 = dateParserFn(Globalize("de-DE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"M/d/yyyy","digitsRe":/\d/});
Globalize.b1446176130 = dateParserFn(Globalize("de-DE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"yyyy.MM.dd","digitsRe":/\d/});
Globalize.a1186958017 = dateParserFn(Globalize("de-DE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"EEEEE","digitsRe":/\d/,"gregorian/days/format/narrow":[["sun",/^S/],["mon",/^M/],["tue",/^D/],["wed",/^M/],["thu",/^D/],["fri",/^F/],["sat",/^S/]]});
Globalize.b1347215202 = dateParserFn(Globalize("de-DE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"EEEE","digitsRe":/\d/,"gregorian/days/format/wide":[["thu",/^Donnerstag/],["tue",/^Dienstag/],["wed",/^Mittwoch/],["sun",/^Sonntag/],["fri",/^Freitag/],["sat",/^Samstag/],["mon",/^Montag/]]});
Globalize.a1694506654 = dateParserFn(Globalize("de-DE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"MMMM","digitsRe":/\d/,"gregorian/months/format/wide":[["9",/^September/],["11",/^November/],["12",/^Dezember/],["2",/^Februar/],["10",/^Oktober/],["1",/^Januar/],["8",/^August/],["4",/^April/],["3",/^März/],["6",/^Juni/],["7",/^Juli/],["5",/^Mai/]]});
Globalize.a471128834 = dateParserFn(Globalize("de-DE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d","digitsRe":/\d/});
Globalize.b1957365103 = dateParserFn(Globalize("de-DE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"M/d/yy","digitsRe":/\d/});
Globalize.b2076957040 = dateParserFn(Globalize("de-DE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d. MMM","digitsRe":/\d/,"gregorian/months/format/abbreviated":[["9",/^Sept\./],["1",/^Jan\./],["2",/^Feb\./],["4",/^Apr\./],["8",/^Aug\./],["10",/^Okt\./],["11",/^Nov\./],["12",/^Dez\./],["3",/^März/],["6",/^Juni/],["7",/^Juli/],["5",/^Mai/]]});
Globalize.a19480057 = dateParserFn(Globalize("de-DE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d. MMMM","digitsRe":/\d/,"gregorian/months/format/wide":[["9",/^September/],["11",/^November/],["12",/^Dezember/],["2",/^Februar/],["10",/^Oktober/],["1",/^Januar/],["8",/^August/],["4",/^April/],["3",/^März/],["6",/^Juni/],["7",/^Juli/],["5",/^Mai/]]});
Globalize.b1634064420 = dateParserFn(Globalize("de-DE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d. MMMM y","digitsRe":/\d/,"gregorian/months/format/wide":[["9",/^September/],["11",/^November/],["12",/^Dezember/],["2",/^Februar/],["10",/^Oktober/],["1",/^Januar/],["8",/^August/],["4",/^April/],["3",/^März/],["6",/^Juni/],["7",/^Juli/],["5",/^Mai/]]});
Globalize.b606961724 = dateParserFn(Globalize("de-DE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"MMMM y","digitsRe":/\d/,"gregorian/months/format/wide":[["9",/^September/],["11",/^November/],["12",/^Dezember/],["2",/^Februar/],["10",/^Oktober/],["1",/^Januar/],["8",/^August/],["4",/^April/],["3",/^März/],["6",/^Juni/],["7",/^Juli/],["5",/^Mai/]]});
Globalize.b606276531 = dateParserFn(Globalize("de-DE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d. MMM y","digitsRe":/\d/,"gregorian/months/format/abbreviated":[["9",/^Sept\./],["1",/^Jan\./],["2",/^Feb\./],["4",/^Apr\./],["8",/^Aug\./],["10",/^Okt\./],["11",/^Nov\./],["12",/^Dez\./],["3",/^März/],["6",/^Juni/],["7",/^Juli/],["5",/^Mai/]]});
Globalize.b1340049712 = dateParserFn(Globalize("de-DE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"EEEE, d. MMM","digitsRe":/\d/,"gregorian/days/format/wide":[["thu",/^Donnerstag/],["tue",/^Dienstag/],["wed",/^Mittwoch/],["sun",/^Sonntag/],["fri",/^Freitag/],["sat",/^Samstag/],["mon",/^Montag/]],"gregorian/months/format/abbreviated":[["9",/^Sept\./],["1",/^Jan\./],["2",/^Feb\./],["4",/^Apr\./],["8",/^Aug\./],["10",/^Okt\./],["11",/^Nov\./],["12",/^Dez\./],["3",/^März/],["6",/^Juni/],["7",/^Juli/],["5",/^Mai/]]});
Globalize.a12091889 = dateParserFn(Globalize("de-DE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"E, d. MMM","digitsRe":/\d/,"gregorian/days/format/abbreviated":[["sun",/^So\./],["mon",/^Mo\./],["tue",/^Di\./],["wed",/^Mi\./],["thu",/^Do\./],["fri",/^Fr\./],["sat",/^Sa\./]],"gregorian/months/format/abbreviated":[["9",/^Sept\./],["1",/^Jan\./],["2",/^Feb\./],["4",/^Apr\./],["8",/^Aug\./],["10",/^Okt\./],["11",/^Nov\./],["12",/^Dez\./],["3",/^März/],["6",/^Juni/],["7",/^Juli/],["5",/^Mai/]]});
module.exports = Globalize;
